/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfAddressDto } from "../models/AjaxResponseOfAddressDto";
import type { AjaxResponseOfGetConfigurationOutputDto } from "../models/AjaxResponseOfGetConfigurationOutputDto";
import type { AjaxResponseOfListOfGetPhoneNumbersOutputDto } from "../models/AjaxResponseOfListOfGetPhoneNumbersOutputDto";
import type { AjaxResponseOfViaCepZipCodeDto } from "../models/AjaxResponseOfViaCepZipCodeDto";
import type { CreateOrEditDefaultConfigurationVendorDto } from "../models/CreateOrEditDefaultConfigurationVendorDto";
import type { CreateOrEditMainAddressDto } from "../models/CreateOrEditMainAddressDto";
import type { CreateOrEditPhoneNumberVendorDto } from "../models/CreateOrEditPhoneNumberVendorDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class ConfigurationAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEditPhoneVendor({
    requestBody,
  }: {
    requestBody?: CreateOrEditPhoneNumberVendorDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/configuration/create-or-edit-phone-vendor",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfListOfGetPhoneNumbersOutputDto
   * @throws ApiError
   */
  public getVendorPhones({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfListOfGetPhoneNumbersOutputDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/configuration/get-vendor-phones",
      query: {
        vendorId: vendorId,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public deletePhoneVendor({
    phoneId,
  }: {
    phoneId?: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/configuration/delete-vendor-phone",
      query: {
        phoneId: phoneId,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEditAddress({
    requestBody,
  }: {
    requestBody?: CreateOrEditMainAddressDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/configuration/create-or-edit-main-address-vendor",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfAddressDto
   * @throws ApiError
   */
  public getVendorMainAddress({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfAddressDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/configuration/get-vendor-main-address",
      query: {
        vendorId: vendorId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetConfigurationOutputDto
   * @throws ApiError
   */
  public defaultConfiguration({
    requestBody,
  }: {
    requestBody?: CreateOrEditDefaultConfigurationVendorDto;
  }): CancelablePromise<AjaxResponseOfGetConfigurationOutputDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/configuration",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfGetConfigurationOutputDto
   * @throws ApiError
   */
  public getConfiguration({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfGetConfigurationOutputDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/configuration",
      query: {
        vendorId: vendorId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfViaCepZipCodeDto
   * @throws ApiError
   */
  public viaCepResponse({
    zipcode,
  }: {
    zipcode?: string;
  }): CancelablePromise<AjaxResponseOfViaCepZipCodeDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/configuration/via-cep",
      query: {
        zipcode: zipcode,
      },
    });
  }
}
